import * as React from 'react';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { Icon } from '../Icon/Icon.js';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './HeaderBrand.scss.js';

const bem = Bem.create("vai-header-brand");
function HeaderBrand({ visible, animated = true, className, htmlId, dataTa, ...rest }) {
  const id = useId(htmlId, ["header branding"]);
  const classes = addClass(bem.block(visible ? "visible" : "hidden", animated && "animated"), className);
  return /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    className: classes,
    "data-ta": dataTa,
    ...rest
  }, /* @__PURE__ */ React.createElement("div", {
    className: bem.element("container")(visible ? "visible" : "hidden")
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: VaiIcon.VaisalaLogoLarge,
    className: bem.element("content")()
  })));
}

export { HeaderBrand };
